module.exports = __webpack_public_path__ + "static/img/workspace-2.06050ff.svg";